import { api } from 'data/api/api'

import { urlWithParams } from '@marketplace-web/shared/utils'

import { GenerateUsernameSuggestionResp } from '../types/username-suggestion'

export const getUsernameSuggestion = (fullname: string, methods?: Array<string>) => {
  let url = '/users/generate_username'

  if (methods && methods.length > 0) {
    url = urlWithParams(url, {
      methods,
      limit: methods?.length,
    })
  }

  return api.post<GenerateUsernameSuggestionResp>(url, {
    fullname,
  })
}
